// Shared emoji dataset + shortcode resolution. Extracted from EmojiPicker so the
// composer (`:shortcode:` autocomplete) and the renderer (`:smile:` → 😄) can
// reuse the same data. Ported for parity with cyborg7-core's src/lib/emoji.ts.

export interface EmojiCategory {
  id: string;
  label: string;
  icon: string;
  emojis: string[];
}

export const EMOJI_CATEGORIES: EmojiCategory[] = [
  { id: "frequent", label: "Frequently Used", icon: "🕐", emojis: [] },
  {
    id: "smileys",
    label: "Smileys & People",
    icon: "😀",
    emojis: [
      "😀",
      "😃",
      "😄",
      "😁",
      "😆",
      "😅",
      "🤣",
      "😂",
      "🙂",
      "🙃",
      "😉",
      "😊",
      "😇",
      "🥰",
      "😍",
      "🤩",
      "😘",
      "😗",
      "😚",
      "😙",
      "🥲",
      "😋",
      "😛",
      "😜",
      "🤪",
      "😝",
      "🤑",
      "🤗",
      "🤭",
      "🤫",
      "🤔",
      "🫡",
      "🤐",
      "🤨",
      "😐",
      "😑",
      "😶",
      "🫥",
      "😏",
      "😒",
      "🙄",
      "😬",
      "🤥",
      "😌",
      "😔",
      "😪",
      "🤤",
      "😴",
      "😷",
      "🤒",
      "🤕",
      "🤢",
      "🤮",
      "🥵",
      "🥶",
      "🥴",
      "😵",
      "🤯",
      "🤠",
      "🥳",
      "🥸",
      "😎",
      "🤓",
      "🧐",
      "😕",
      "🫤",
      "😟",
      "🙁",
      "😮",
      "😯",
      "😲",
      "😳",
      "🥺",
      "🥹",
      "😦",
      "😧",
      "😨",
      "😰",
      "😥",
      "😢",
      "😭",
      "😱",
      "😖",
      "😣",
      "😞",
      "😓",
      "😩",
      "😫",
      "🥱",
      "😤",
      "😡",
      "😠",
      "🤬",
      "😈",
      "👿",
      "💀",
      "☠️",
      "💩",
      "🤡",
      "👹",
      "👺",
      "👻",
      "👽",
      "👾",
      "🤖",
      "🫠",
      "🫣",
      "🫢",
      "🫶",
      "😮‍💨",
      "😵‍💫",
      "❤️‍🔥",
      "❤️‍🩹",
    ],
  },
  {
    id: "people",
    label: "People & Body",
    icon: "🧑",
    emojis: [
      "👶",
      "🧒",
      "👦",
      "👧",
      "🧑",
      "👱",
      "👨",
      "🧔",
      "👩",
      "🧓",
      "👴",
      "👵",
      "👀",
      "👁️",
      "👃",
      "👅",
      "👄",
      "🫦",
      "🦷",
      "🦴",
      "🧠",
      "🫀",
      "🫁",
      "👂",
      "🦻",
      "🦶",
      "🦵",
      "🦿",
      "🦾",
      "💇",
      "💆",
      "🧖",
      "🧗",
      "🧘",
      "🛀",
      "🛌",
      "🏃",
      "🚶",
      "🧍",
      "🧎",
      "💃",
      "🕺",
      "👯",
      "🧑‍💻",
      "👨‍💻",
      "👩‍💻",
      "🧑‍🍳",
      "👨‍🍳",
      "👩‍🍳",
      "🧑‍🎓",
      "👨‍🎓",
      "👩‍🎓",
      "🧑‍🏫",
      "🧑‍⚕️",
      "🧑‍🔬",
      "🧑‍🎨",
      "🧑‍🚀",
      "🧑‍🚒",
      "👮",
      "🕵️",
      "💂",
      "🥷",
      "🧑‍🌾",
      "👒",
      "🧢",
      "👑",
      "🎩",
      "🎓",
      "⛑️",
      "👓",
      "🕶️",
      "🥽",
      "🧣",
      "🧤",
      "🧥",
      "👔",
      "👕",
      "👖",
      "🩳",
      "👗",
      "👘",
      "🥻",
      "🩱",
      "👙",
      "👚",
      "👛",
      "👜",
      "👝",
      "🎒",
      "🩴",
      "👞",
      "👟",
      "🥾",
      "🥿",
      "👠",
      "👡",
      "🩰",
      "👢",
    ],
  },
  {
    id: "gestures",
    label: "Hands & Gestures",
    icon: "👋",
    emojis: [
      "👋",
      "🤚",
      "🖐️",
      "✋",
      "🖖",
      "🫱",
      "🫲",
      "🫳",
      "🫴",
      "👌",
      "🤌",
      "🤏",
      "✌️",
      "🤞",
      "🫰",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝️",
      "🫵",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "🫶",
      "👐",
      "🤲",
      "🤝",
      "🙏",
      "✍️",
      "💅",
      "🤳",
      "💪",
    ],
  },
  {
    id: "nature",
    label: "Animals & Nature",
    icon: "🐶",
    emojis: [
      "🐶",
      "🐱",
      "🐭",
      "🐹",
      "🐰",
      "🦊",
      "🐻",
      "🐼",
      "🐻‍❄️",
      "🐨",
      "🐯",
      "🦁",
      "🐮",
      "🐷",
      "🐸",
      "🐵",
      "🙈",
      "🙉",
      "🙊",
      "🐒",
      "🐔",
      "🐧",
      "🐦",
      "🐤",
      "🦆",
      "🦅",
      "🦉",
      "🦇",
      "🐺",
      "🐗",
      "🐴",
      "🦄",
      "🐝",
      "🪱",
      "🐛",
      "🦋",
      "🐌",
      "🐞",
      "🐜",
      "🪰",
      "🐙",
      "🦑",
      "🦀",
      "🦞",
      "🦐",
      "🐡",
      "🐠",
      "🐟",
      "🐬",
      "🐳",
      "🐋",
      "🦈",
      "🐊",
      "🐅",
      "🐆",
      "🦓",
      "🦍",
      "🦧",
      "🐘",
      "🦛",
      "🦏",
      "🐪",
      "🐫",
      "🦒",
      "🦘",
      "🦬",
      "🐃",
      "🐂",
      "🐄",
      "🐎",
      "🐖",
      "🐏",
      "🐑",
      "🦙",
      "🐐",
      "🦌",
      "🐕",
      "🐩",
      "🦮",
      "🐈",
      "🐓",
      "🦃",
      "🦤",
      "🦚",
      "🦜",
      "🦢",
      "🦩",
      "🕊️",
      "🐇",
      "🦝",
      "🦨",
      "🦡",
      "🦫",
      "🦦",
      "🦥",
      "🐁",
      "🐀",
      "🐿️",
      "🦔",
      "🐉",
      "🦕",
      "🦖",
      "🐢",
      "🦎",
      "🐍",
      "🪲",
      "🪳",
      "🦗",
      "🕷️",
      "🕸️",
      "🦂",
      "🦟",
      "🦠",
      "🌸",
      "💐",
      "🌷",
      "🌹",
      "🥀",
      "🌺",
      "🌻",
      "🌼",
      "🌱",
      "🌲",
      "🌳",
      "🌴",
      "🌵",
      "🍀",
      "☘️",
      "🍃",
      "🍂",
      "🍁",
      "🍄",
      "🪨",
      "🪵",
      "🌾",
      "🌿",
      "🪴",
      "🪹",
      "🪺",
    ],
  },
  {
    id: "food",
    label: "Food & Drink",
    icon: "🍔",
    emojis: [
      "🍎",
      "🍐",
      "🍊",
      "🍋",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🫐",
      "🍈",
      "🍒",
      "🍑",
      "🥭",
      "🍍",
      "🥥",
      "🥝",
      "🍅",
      "🍆",
      "🥑",
      "🫛",
      "🥦",
      "🥬",
      "🥒",
      "🌶️",
      "🫑",
      "🌽",
      "🥕",
      "🫒",
      "🧄",
      "🧅",
      "🥔",
      "🍠",
      "🫚",
      "🥐",
      "🍞",
      "🥖",
      "🥨",
      "🧀",
      "🥚",
      "🍳",
      "🥞",
      "🧇",
      "🥓",
      "🍔",
      "🍟",
      "🍕",
      "🌭",
      "🥪",
      "🌮",
      "🌯",
      "🫔",
      "🥗",
      "🍝",
      "🍜",
      "🍲",
      "🍛",
      "🍣",
      "🍱",
      "🥟",
      "🍤",
      "🍩",
      "🍪",
      "🎂",
      "🍰",
      "🧁",
      "🥧",
      "🍫",
      "🍬",
      "🍭",
      "🍮",
      "🍯",
      "☕",
      "🫖",
      "🍵",
      "🧃",
      "🥤",
      "🧋",
      "🍶",
      "🍺",
      "🍻",
      "🥂",
      "🍷",
      "🍸",
      "🍹",
      "🧉",
      "🧑‍🍳",
      "👨‍🍳",
      "👩‍🍳",
      "🥘",
      "🫕",
      "🥡",
      "🧆",
      "🥙",
      "🫓",
      "🥜",
      "🌰",
      "🍿",
    ],
  },
  {
    id: "activity",
    label: "Activities",
    icon: "⚽",
    emojis: [
      "⚽",
      "🏀",
      "🏈",
      "⚾",
      "🥎",
      "🎾",
      "🏐",
      "🏉",
      "🥏",
      "🎱",
      "🪀",
      "🏓",
      "🏸",
      "🏒",
      "🥍",
      "🏏",
      "🪃",
      "🥅",
      "⛳",
      "🪁",
      "🎯",
      "🎳",
      "🎮",
      "🕹️",
      "🎰",
      "🧩",
      "♟️",
      "🎭",
      "🎨",
      "🎬",
      "🎤",
      "🎧",
      "🎼",
      "🎹",
      "🥁",
      "🪘",
      "🎷",
      "🎺",
      "🪗",
      "🎸",
      "🎻",
      "🎲",
      "🏆",
      "🥇",
      "🥈",
      "🥉",
      "🏅",
      "🎖️",
      "🎗️",
      "🎪",
      "🎟️",
      "🎫",
      "🏄",
      "🏊",
      "🤽",
      "🚣",
      "🧗",
      "🏋️",
      "🤸",
      "⛹️",
      "🤺",
      "🏇",
      "⛷️",
      "🏂",
      "🪂",
      "🏌️",
      "🤼",
      "🤾",
    ],
  },
  {
    id: "travel",
    label: "Travel & Places",
    icon: "✈️",
    emojis: [
      "🚗",
      "🚕",
      "🚙",
      "🚌",
      "🚎",
      "🏎️",
      "🚓",
      "🚑",
      "🚒",
      "🚐",
      "🛻",
      "🚚",
      "🚛",
      "🚜",
      "🏍️",
      "🛵",
      "🚲",
      "🛴",
      "🛹",
      "🛼",
      "🚁",
      "✈️",
      "🛩️",
      "🚀",
      "🛸",
      "🚢",
      "⛵",
      "🚤",
      "🛥️",
      "⛴️",
      "🗽",
      "🗼",
      "🏰",
      "🏯",
      "🏟️",
      "🎡",
      "🎢",
      "🎠",
      "⛱️",
      "🏖️",
      "🏝️",
      "🏜️",
      "🌋",
      "⛰️",
      "🏔️",
      "🗻",
      "🏕️",
      "🏠",
      "🏡",
      "🏢",
      "🏗️",
      "🌄",
      "🌅",
      "🌆",
      "🌇",
      "🌉",
      "🌌",
      "🌍",
      "🌎",
      "🌏",
      "🗺️",
      "🌐",
      "🧭",
      "🏛️",
      "🏥",
      "🏦",
      "🏨",
      "🏩",
      "🏪",
      "🏫",
      "🏬",
      "🏭",
      "🏮",
      "⛩️",
      "⛪",
      "🕌",
      "🕍",
      "🛕",
      "🕋",
    ],
  },
  {
    id: "objects",
    label: "Objects",
    icon: "💡",
    emojis: [
      "⌚",
      "📱",
      "📲",
      "💻",
      "⌨️",
      "🖥️",
      "🖨️",
      "🖱️",
      "🖲️",
      "🕹️",
      "🗜️",
      "💾",
      "💿",
      "📀",
      "📷",
      "📸",
      "📹",
      "🎥",
      "📽️",
      "🎞️",
      "📞",
      "☎️",
      "📟",
      "📠",
      "📺",
      "📻",
      "🎙️",
      "🎚️",
      "🎛️",
      "🧭",
      "⏰",
      "⏳",
      "⌛",
      "📡",
      "🔋",
      "🔌",
      "💡",
      "🔦",
      "🕯️",
      "🧯",
      "💰",
      "💵",
      "💴",
      "💶",
      "💷",
      "💳",
      "💎",
      "⚖️",
      "🪜",
      "🧰",
      "🪛",
      "🔧",
      "🔨",
      "⚒️",
      "🛠️",
      "⛏️",
      "🪚",
      "🔩",
      "⚙️",
      "🧲",
      "📌",
      "📍",
      "✂️",
      "📎",
      "🖇️",
      "📐",
      "📏",
      "🧮",
      "📝",
      "✏️",
      "🖊️",
      "🖋️",
      "🔑",
      "🗝️",
      "🔐",
      "🔒",
      "🔓",
      "🪥",
      "🧴",
      "🧷",
      "🧹",
      "🧺",
      "🧻",
      "🪣",
      "🧼",
      "🫧",
      "🧽",
      "🛒",
      "🪝",
      "🪤",
      "🪆",
      "🧸",
      "🪅",
      "🎈",
      "🎉",
      "🎊",
      "🎁",
      "🎀",
      "🎏",
      "🎐",
      "🎑",
      "🧧",
      "📚",
      "📖",
      "📕",
      "📗",
      "📘",
      "📙",
      "📓",
      "📔",
      "📒",
      "📃",
      "📜",
      "📄",
      "📰",
      "🗞️",
      "📑",
      "🔖",
      "🏷️",
      "📦",
      "📫",
      "📪",
      "📬",
      "📭",
      "📮",
      "🗳️",
      "📥",
      "📤",
      "🛡️",
      "🗡️",
      "⚔️",
      "🔫",
      "🪃",
      "🏹",
      "💣",
      "🪓",
      "🔪",
      "🩸",
      "💊",
      "💉",
      "🩹",
      "🩺",
      "🩻",
      "🩼",
      "🔬",
      "🔭",
      "🧬",
      "🧪",
      "🧫",
    ],
  },
  {
    id: "symbols",
    label: "Symbols",
    icon: "❤️",
    emojis: [
      "❤️",
      "🧡",
      "💛",
      "💚",
      "💙",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❣️",
      "💕",
      "💞",
      "💓",
      "💗",
      "💖",
      "💘",
      "💝",
      "💟",
      "✅",
      "❌",
      "❓",
      "❗",
      "‼️",
      "⁉️",
      "💯",
      "🔥",
      "⭐",
      "🌟",
      "✨",
      "⚡",
      "💥",
      "💫",
      "🕐",
      "🕑",
      "🕒",
      "🕓",
      "🕔",
      "🕕",
      "♻️",
      "⚠️",
      "🚫",
      "🔞",
      "📵",
      "🚷",
      "🚯",
      "🚳",
      "🚱",
      "🔔",
      "🔕",
      "🎵",
      "🎶",
      "💤",
      "♾️",
      "♿",
      "🏧",
      "🅿️",
      "🆗",
      "🆕",
      "🆙",
      "🆒",
      "🆓",
      "🆖",
      "🔤",
      "🔡",
      "🔠",
      "🔣",
      "🔢",
      "#️⃣",
      "*️⃣",
      "0️⃣",
      "1️⃣",
      "2️⃣",
      "3️⃣",
      "☮️",
      "✝️",
      "☪️",
      "🕉️",
      "☸️",
      "✡️",
      "🔯",
      "🕎",
      "☯️",
      "☦️",
      "🛐",
      "⛎",
      "♈",
      "♉",
      "♊",
      "♋",
      "♌",
      "♍",
      "♎",
      "♏",
      "♐",
      "♑",
      "♒",
      "♓",
      "🔴",
      "🟠",
      "🟡",
      "🟢",
      "🔵",
      "🟣",
      "🟤",
      "⚫",
      "⚪",
      "🟥",
      "🟧",
      "🟨",
      "🟩",
      "🟦",
      "🟪",
      "🟫",
      "⬛",
      "⬜",
      "◼️",
      "◻️",
      "▪️",
      "▫️",
      "🔶",
      "🔷",
      "🔸",
      "🔹",
      "🔺",
      "🔻",
    ],
  },
  {
    id: "flags",
    label: "Flags",
    icon: "🏁",
    emojis: [
      "🏁",
      "🚩",
      "🎌",
      "🏴",
      "🏳️",
      "🏳️‍🌈",
      "🏳️‍⚧️",
      "🏴‍☠️",
      "🇺🇸",
      "🇬🇧",
      "🇫🇷",
      "🇩🇪",
      "🇪🇸",
      "🇮🇹",
      "🇯🇵",
      "🇰🇷",
      "🇨🇳",
      "🇷🇺",
      "🇧🇷",
      "🇲🇽",
      "🇨🇴",
      "🇦🇷",
      "🇨🇱",
      "🇵🇪",
      "🇨🇦",
      "🇦🇺",
      "🇮🇳",
      "🇵🇹",
      "🇳🇱",
      "🇧🇪",
      "🇨🇭",
      "🇦🇹",
      "🇸🇪",
      "🇳🇴",
      "🇩🇰",
      "🇫🇮",
      "🇵🇱",
      "🇺🇦",
      "🇹🇷",
      "🇸🇦",
      "🇦🇪",
      "🇮🇱",
      "🇧🇴",
      "🇵🇾",
      "🇺🇾",
      "🇻🇪",
      "🇪🇨",
      "🇨🇷",
      "🇵🇦",
      "🇨🇺",
      "🇩🇴",
      "🇬🇹",
      "🇭🇳",
      "🇸🇻",
      "🇳🇮",
      "🇵🇷",
    ],
  },
];

export const EMOJI_NAMES: Record<string, string[]> = {
  "😀": ["grinning", "happy", "smile"],
  "😃": ["smiley", "happy"],
  "😄": ["smile", "happy", "joy"],
  "😁": ["grin", "happy"],
  "😆": ["laughing", "lol"],
  "😅": ["sweat", "nervous", "laugh"],
  "🤣": ["rofl", "laughing"],
  "😂": ["joy", "tears", "laugh", "lol", "crying"],
  "🙂": ["slightly smiling"],
  "🙃": ["upside down"],
  "😉": ["wink"],
  "😊": ["blush", "happy", "smile"],
  "😇": ["angel", "innocent", "halo"],
  "🥰": ["love", "hearts", "adore"],
  "😍": ["heart eyes", "love"],
  "🤩": ["star struck", "excited", "wow", "cool"],
  "😘": ["kiss", "love"],
  "😗": ["kissing"],
  "😚": ["kiss", "blush"],
  "😙": ["kiss", "whistle"],
  "🥲": ["happy tear"],
  "😋": ["yummy", "delicious", "tongue"],
  "😛": ["tongue out"],
  "😜": ["wink tongue", "crazy"],
  "🤪": ["zany", "crazy", "wild"],
  "😝": ["tongue", "squint"],
  "🤑": ["money", "rich", "dollar"],
  "🤗": ["hug", "hugging"],
  "🤭": ["oops", "giggle"],
  "🤫": ["shush", "quiet", "secret"],
  "🤔": ["thinking", "hmm", "wonder"],
  "🫡": ["salute"],
  "🤐": ["zipper", "quiet", "mute"],
  "🤨": ["raised eyebrow", "suspicious"],
  "😐": ["neutral", "meh"],
  "😑": ["expressionless", "blank"],
  "😶": ["no mouth", "silent", "mute"],
  "😏": ["smirk"],
  "😒": ["unamused", "annoyed"],
  "🙄": ["eye roll", "whatever"],
  "😬": ["grimace", "awkward", "cringe"],
  "😌": ["relieved", "peaceful"],
  "😔": ["pensive", "sad"],
  "😪": ["sleepy", "tired"],
  "🤤": ["drooling"],
  "😴": ["sleeping", "zzz", "tired", "sleep"],
  "😷": ["mask", "sick", "covid"],
  "🤒": ["sick", "thermometer", "fever", "ill"],
  "🤕": ["hurt", "bandage", "injured"],
  "🤢": ["nauseous", "sick", "green"],
  "🤮": ["vomit", "sick", "throw up"],
  "🥵": ["hot", "heat", "sweating"],
  "🥶": ["cold", "freezing", "ice"],
  "🥴": ["woozy", "drunk", "dizzy"],
  "😵": ["dizzy", "knocked out"],
  "🤯": ["mind blown", "exploding", "wow"],
  "🤠": ["cowboy", "yeehaw"],
  "🥳": ["party", "celebrate", "birthday"],
  "🥸": ["disguise", "incognito"],
  "😎": ["cool", "sunglasses", "awesome"],
  "🤓": ["nerd", "geek", "glasses"],
  "🧐": ["monocle", "inspect", "curious"],
  "😕": ["confused"],
  "😟": ["worried"],
  "🙁": ["slightly frowning", "sad"],
  "😮": ["surprised", "oh"],
  "😯": ["hushed", "wow"],
  "😲": ["astonished", "shocked", "wow"],
  "😳": ["flushed", "embarrassed"],
  "🥺": ["pleading", "puppy eyes", "please"],
  "🥹": ["holding back tears", "emotional"],
  "😨": ["fearful", "scared"],
  "😰": ["anxious", "nervous", "sweat"],
  "😥": ["disappointed", "sad"],
  "😢": ["crying", "sad", "tear"],
  "😭": ["sobbing", "crying", "sad", "bawling"],
  "😱": ["scream", "scared", "horror"],
  "😖": ["confounded"],
  "😣": ["persevering"],
  "😞": ["disappointed", "sad"],
  "😓": ["downcast", "sweat"],
  "😩": ["weary", "tired"],
  "😫": ["tired", "exhausted"],
  "🥱": ["yawn", "bored", "tired", "sleepy"],
  "😤": ["triumph", "frustrated", "angry"],
  "😡": ["angry", "mad", "rage"],
  "😠": ["angry", "mad"],
  "🤬": ["swearing", "cursing", "angry"],
  "😈": ["devil", "evil", "mischievous"],
  "👿": ["angry devil"],
  "💀": ["skull", "dead", "death"],
  "☠️": ["skull crossbones", "danger", "death"],
  "💩": ["poop", "shit"],
  "🤡": ["clown"],
  "👹": ["ogre", "monster"],
  "👺": ["goblin"],
  "👻": ["ghost", "boo", "halloween"],
  "👽": ["alien", "ufo"],
  "👾": ["space invader", "game"],
  "🤖": ["robot", "bot"],
  "👋": ["wave", "hello", "hi", "bye"],
  "🤚": ["raised hand", "stop"],
  "🖐️": ["hand", "five"],
  "✋": ["hand", "stop", "high five"],
  "👌": ["ok", "perfect", "nice"],
  "🤌": ["pinched", "italian"],
  "✌️": ["peace", "victory"],
  "🤞": ["fingers crossed", "luck", "hope"],
  "🤟": ["love you", "rock"],
  "🤘": ["rock on", "metal"],
  "🤙": ["call me", "shaka"],
  "👍": ["thumbs up", "yes", "good", "like", "ok"],
  "👎": ["thumbs down", "no", "bad", "dislike"],
  "✊": ["fist", "solidarity"],
  "👊": ["fist bump", "punch"],
  "👏": ["clap", "applause", "bravo"],
  "🙌": ["celebration", "hooray", "hands up"],
  "🤝": ["handshake", "deal", "agreement"],
  "🙏": ["pray", "please", "thanks", "namaste", "hope"],
  "✍️": ["writing", "write"],
  "💪": ["muscle", "strong", "flex", "bicep", "power"],
  "🫶": ["heart hands", "love"],
  "🔥": ["fire", "hot", "lit", "awesome"],
  "⭐": ["star", "favorite"],
  "🌟": ["glowing star", "sparkle"],
  "✨": ["sparkles", "magic", "clean"],
  "⚡": ["lightning", "zap", "energy", "fast"],
  "💡": ["idea", "light bulb", "think"],
  "🎉": ["party", "tada", "celebrate", "congrats"],
  "✅": ["check", "done", "complete", "yes"],
  "❌": ["cross", "no", "wrong", "delete"],
  "❓": ["question"],
  "❗": ["exclamation", "alert"],
  "💯": ["hundred", "perfect", "score"],
  "⏰": ["alarm", "clock", "time", "wake up"],
  "🔔": ["bell", "notification", "alert"],
  "💤": ["sleep", "zzz", "tired", "snore"],
  "🎵": ["music", "note", "song"],
  "🎶": ["music", "notes"],
  "🌙": ["moon", "night", "sleep"],
  "☀️": ["sun", "sunny", "weather", "bright"],
  "📅": ["calendar", "date", "meeting", "schedule"],
  "🚌": ["bus", "commute", "transit"],
  "🌴": ["palm tree", "vacation", "tropical", "beach"],
  "🏠": ["home", "house"],
  "🎯": ["target", "goal", "bullseye", "direct hit"],
  "💻": ["laptop", "computer", "work", "code"],
  "📞": ["phone", "call", "telephone"],
  "🍽️": ["dinner", "food", "eating", "lunch"],
  "☕": ["coffee", "cafe", "tea", "morning"],
  "🏃": ["running", "exercise", "run"],
  "📚": ["books", "study", "reading", "learn", "library"],
  "💔": ["broken heart", "sad"],
  "❤️": ["heart", "love", "red heart"],
  "🧡": ["orange heart"],
  "💛": ["yellow heart"],
  "💚": ["green heart"],
  "💙": ["blue heart"],
  "💜": ["purple heart"],
  "🖤": ["black heart"],
  "🤍": ["white heart"],
  "🏆": ["trophy", "winner", "champion", "first"],
  "🥇": ["gold medal", "first", "winner"],
  "🥈": ["silver medal", "second"],
  "🥉": ["bronze medal", "third"],
  "🚀": ["rocket", "launch", "ship", "fast", "startup"],
  "🎮": ["gaming", "video game", "controller", "play"],
  "🍕": ["pizza", "food"],
  "🍔": ["burger", "hamburger", "food"],
  "🍺": ["beer", "drink", "cheers"],
  "🍷": ["wine", "drink"],
  "🥂": ["champagne", "cheers", "toast", "celebrate"],
  "🎂": ["birthday", "cake", "celebrate"],
  "🎁": ["gift", "present", "birthday"],
  "📱": ["phone", "mobile", "iphone"],
  "🖥️": ["desktop", "computer", "monitor"],
  "⌨️": ["keyboard", "typing"],
  "🔑": ["key", "password", "security"],
  "🔒": ["lock", "secure", "locked"],
  "🔓": ["unlock", "open"],
  "📝": ["memo", "note", "writing", "write"],
  "💰": ["money", "bag", "rich", "dollar"],
  "💵": ["dollar", "money", "cash"],
  "💎": ["diamond", "gem", "luxury"],
  "🏖️": ["beach", "vacation", "summer"],
  "✈️": ["airplane", "travel", "flight", "plane"],
  "🚗": ["car", "driving", "automobile"],
  "🏡": ["house", "home", "garden"],
  "🌈": ["rainbow"],
  "🇺🇸": ["usa", "united states", "america"],
  "🇬🇧": ["uk", "britain", "england"],
  "🇫🇷": ["france", "french"],
  "🇩🇪": ["germany", "german"],
  "🇪🇸": ["spain", "spanish"],
  "🇮🇹": ["italy", "italian"],
  "🇯🇵": ["japan", "japanese"],
  "🇰🇷": ["korea", "korean"],
  "🇨🇳": ["china", "chinese"],
  "🇧🇷": ["brazil", "brazilian"],
  "🇲🇽": ["mexico", "mexican"],
  "🇨🇴": ["colombia", "colombian"],
  "🇦🇷": ["argentina"],
  "🇨🇦": ["canada", "canadian"],
  "🇦🇺": ["australia", "australian"],
  "🇮🇳": ["india", "indian"],
  "🇧🇴": ["bolivia", "bolivian"],
  "🇵🇾": ["paraguay"],
  "🇺🇾": ["uruguay"],
  "🇻🇪": ["venezuela"],
  "🇪🇨": ["ecuador"],
  "🇨🇷": ["costa rica"],
  "🇵🇦": ["panama"],
  "🇨🇺": ["cuba"],
  "🇩🇴": ["dominican republic"],
  "🇬🇹": ["guatemala"],
  "🇭🇳": ["honduras"],
  "🇸🇻": ["el salvador"],
  "🇳🇮": ["nicaragua"],
  "🇵🇷": ["puerto rico"],
  "🫠": ["melting", "disappearing", "sarcasm"],
  "🫣": ["peeking", "shy", "one eye"],
  "🫢": ["hand over mouth", "surprised", "oops"],
  "😮‍💨": ["exhale", "sigh", "relief"],
  "😵‍💫": ["dizzy", "spiral eyes", "hypnotized"],
  "❤️‍🔥": ["heart fire", "passion", "desire"],
  "❤️‍🩹": ["mending heart", "healing", "recovery"],
  "👶": ["baby", "infant"],
  "🧒": ["child", "kid"],
  "👦": ["boy"],
  "👧": ["girl"],
  "🧑": ["person", "adult"],
  "👱": ["blond", "blonde"],
  "👨": ["man"],
  "🧔": ["beard", "bearded"],
  "👩": ["woman"],
  "🧓": ["older person", "elder"],
  "👴": ["old man", "grandpa"],
  "👵": ["old woman", "grandma"],
  "👀": ["eyes", "look", "see", "watching"],
  "👁️": ["eye", "see", "watch"],
  "👃": ["nose", "smell"],
  "👅": ["tongue", "taste", "lick"],
  "👄": ["lips", "mouth", "kiss"],
  "🫦": ["biting lip", "nervous", "flirty"],
  "🦷": ["tooth", "dental", "dentist"],
  "🦴": ["bone", "skeleton"],
  "🧠": ["brain", "smart", "think", "mind", "intelligent"],
  "🫀": ["heart organ", "anatomical heart"],
  "🫁": ["lungs", "breathe", "respiratory"],
  "👂": ["ear", "listen", "hear"],
  "🦻": ["hearing aid", "deaf", "accessibility"],
  "🦶": ["foot", "kick", "step"],
  "🦵": ["leg", "knee"],
  "🦿": ["prosthetic leg", "mechanical leg"],
  "🦾": ["prosthetic arm", "mechanical arm", "robot arm"],
  "💇": ["haircut", "salon", "barber"],
  "💆": ["massage", "spa", "relax"],
  "🧖": ["sauna", "steam", "spa"],
  "🧗": ["climbing", "rock climbing"],
  "🧘": ["meditation", "yoga", "zen"],
  "🛀": ["bath", "bathtub", "relax"],
  "🛌": ["sleeping", "bed", "rest"],
  "💃": ["dancing", "woman dancing", "salsa"],
  "🕺": ["dancing", "man dancing", "disco"],
  "👯": ["dancers", "bunny ears"],
  "🧑‍💻": ["technologist", "programmer", "developer", "coder"],
  "👨‍💻": ["man technologist", "programmer"],
  "👩‍💻": ["woman technologist", "programmer"],
  "🧑‍🍳": ["chef", "cook", "cooking"],
  "👨‍🍳": ["chef", "cook", "man cooking"],
  "👩‍🍳": ["chef", "cook", "woman cooking"],
  "🧑‍🎓": ["student", "graduate", "graduation"],
  "👨‍🎓": ["male student", "graduate"],
  "👩‍🎓": ["female student", "graduate"],
  "🧑‍🏫": ["teacher", "professor", "educator"],
  "🧑‍⚕️": ["doctor", "health", "medical"],
  "🧑‍🔬": ["scientist", "researcher", "lab"],
  "🧑‍🎨": ["artist", "painter", "creative"],
  "🧑‍🚀": ["astronaut", "space", "cosmonaut"],
  "🧑‍🚒": ["firefighter", "fire"],
  "👮": ["police", "cop", "officer"],
  "🕵️": ["detective", "spy", "investigator"],
  "💂": ["guard", "royal guard"],
  "🥷": ["ninja", "stealth"],
  "🧑‍🌾": ["farmer", "agriculture", "garden"],
  "👒": ["hat", "sun hat", "summer"],
  "🧢": ["cap", "baseball cap", "hat"],
  "👑": ["crown", "king", "queen", "royal"],
  "🎩": ["top hat", "formal", "gentleman"],
  "🎓": ["graduation cap", "graduate", "diploma"],
  "⛑️": ["helmet", "rescue", "safety"],
  "👓": ["glasses", "eyeglasses", "reading"],
  "🕶️": ["sunglasses", "cool", "shades"],
  "🥽": ["goggles", "safety glasses", "swim"],
  "👔": ["tie", "necktie", "business", "formal"],
  "👕": ["shirt", "t-shirt", "tee"],
  "👖": ["jeans", "pants", "trousers"],
  "🩳": ["shorts"],
  "👗": ["dress"],
  "👘": ["kimono", "japanese"],
  "👟": ["sneakers", "shoes", "running"],
  "👠": ["high heel", "stiletto", "heels"],
  "🥾": ["hiking boot", "boot"],
  "👢": ["boot", "boots"],
  "👜": ["handbag", "purse", "bag"],
  "🎒": ["backpack", "school", "bag"],
  "🐙": ["octopus"],
  "🦑": ["squid"],
  "🦀": ["crab"],
  "🦞": ["lobster"],
  "🦐": ["shrimp", "prawn"],
  "🐡": ["pufferfish", "blowfish"],
  "🐠": ["tropical fish"],
  "🐟": ["fish"],
  "🐬": ["dolphin"],
  "🐳": ["whale", "spouting"],
  "🐋": ["whale"],
  "🦈": ["shark"],
  "🐊": ["crocodile", "alligator"],
  "🐅": ["tiger"],
  "🐆": ["leopard"],
  "🦓": ["zebra"],
  "🦍": ["gorilla"],
  "🦧": ["orangutan"],
  "🐘": ["elephant"],
  "🦛": ["hippo", "hippopotamus"],
  "🦏": ["rhinoceros", "rhino"],
  "🐪": ["camel"],
  "🐫": ["two hump camel", "bactrian"],
  "🦒": ["giraffe"],
  "🦘": ["kangaroo"],
  "🐉": ["dragon"],
  "🦕": ["dinosaur", "sauropod", "brontosaurus"],
  "🦖": ["t-rex", "dinosaur", "tyrannosaurus"],
  "🐢": ["turtle", "tortoise"],
  "🦎": ["lizard", "gecko"],
  "🐍": ["snake"],
  "🕷️": ["spider"],
  "🕸️": ["spider web", "cobweb"],
  "🦂": ["scorpion"],
  "🦟": ["mosquito"],
  "🦠": ["microbe", "bacteria", "virus", "germ"],
  "🍄": ["mushroom", "fungus"],
  "🪨": ["rock", "stone"],
  "🪵": ["wood", "log"],
  "🪴": ["potted plant", "houseplant"],
  "🪥": ["toothbrush", "dental", "hygiene", "teeth"],
  "🧴": ["lotion", "sunscreen", "moisturizer"],
  "🧹": ["broom", "sweep", "clean"],
  "🧺": ["basket", "laundry"],
  "🧻": ["toilet paper", "roll"],
  "🧼": ["soap", "clean", "wash"],
  "🫧": ["bubbles", "soap", "clean"],
  "🧽": ["sponge", "clean"],
  "🛒": ["shopping cart", "grocery"],
  "🧸": ["teddy bear", "plush", "toy", "stuffed"],
  "🎈": ["balloon", "party"],
  "🎊": ["confetti", "party", "celebrate"],
  "📖": ["book", "open book", "reading"],
  "🛡️": ["shield", "protect", "security", "defense"],
  "🔬": ["microscope", "science", "research"],
  "🔭": ["telescope", "astronomy", "space"],
  "🧬": ["dna", "genetics", "biology", "science"],
  "🧪": ["test tube", "science", "chemistry"],
  "💊": ["pill", "medicine", "drug", "pharmacy"],
  "💉": ["syringe", "injection", "vaccine", "needle"],
  "🩹": ["bandage", "band-aid", "adhesive"],
  "🩺": ["stethoscope", "doctor", "medical"],
  "🏄": ["surfing", "surf", "wave"],
  "🏊": ["swimming", "swim", "pool"],
  "🏋️": ["weightlifting", "gym", "exercise", "fitness"],
  "🤸": ["cartwheel", "gymnastics", "acrobatics"],
  "🤺": ["fencing", "sword"],
  "🏇": ["horse racing", "equestrian"],
  "⛷️": ["skiing", "ski", "snow"],
  "🏂": ["snowboarding", "snow"],
  "🪂": ["parachute", "skydiving"],
  "🌍": ["earth", "globe", "world", "africa", "europe"],
  "🌎": ["earth", "globe", "americas"],
  "🌏": ["earth", "globe", "asia", "australia"],
  "🧭": ["compass", "navigation", "direction"],
};

// shortcode (keyword with spaces→underscores) → emoji, first match wins.
const SHORTCODE_TO_EMOJI: Record<string, string> = (() => {
  const map: Record<string, string> = {};
  for (const [emoji, names] of Object.entries(EMOJI_NAMES)) {
    for (const name of names) {
      const key = name.replace(/\s+/g, "_");
      if (!(key in map)) map[key] = emoji;
    }
  }
  return map;
})();

// Replace `:shortcode:` (both colons required, to avoid eating times/ratios) with
// the emoji glyph. Unknown shortcodes are left untouched.
export function resolveShortcodes(text: string): string {
  return text.replace(
    /:([a-z0-9_+-]+):/g,
    (whole, code: string) => SHORTCODE_TO_EMOJI[code] ?? whole,
  );
}

export interface ShortcodeSuggestion {
  code: string;
  emoji: string;
}

// Prefix-match shortcodes for composer autocomplete (one emoji per result).
export function searchShortcodes(query: string, limit = 8): ShortcodeSuggestion[] {
  const q = query.toLowerCase();
  if (!q) return [];
  const out: ShortcodeSuggestion[] = [];
  const seenEmoji = new Set<string>();
  for (const [code, emoji] of Object.entries(SHORTCODE_TO_EMOJI)) {
    if (code.startsWith(q) && !seenEmoji.has(emoji)) {
      out.push({ code, emoji });
      seenEmoji.add(emoji);
      if (out.length >= limit) break;
    }
  }
  return out;
}

// A field that holds exactly ONE emoji: a reaction, a status emoji, a page icon. Same rule as the
// relay's (server cyborg/emoji-field.ts): RGI via the `v` flag. Without it (iOS 16 WebKit) the
// check is never looser: one-code-point emoji by property, longer sequences only from this set.
const ONE_GLYPH = new RegExp(
  String.raw`^(?:(?!\p{Regional_Indicator})\p{Emoji_Presentation}|\p{Emoji_Modifier_Base}\p{Emoji_Modifier}|(?![0-9#*])(?=\P{Emoji_Presentation})\p{Emoji}\uFE0F|[0-9#*]\uFE0F\u20E3)$`,
  "u",
);
const PICKER_SEQUENCES: ReadonlySet<string> = new Set([
  ...EMOJI_CATEGORIES.flatMap((c) => c.emojis),
  ...Object.keys(EMOJI_NAMES),
]);
// The shape of any emoji sequence (UTS #51), RGI or not: what a stored value an engine without
// the `v` flag cannot prove must look like to be kept as stored.
const ELEMENT = String.raw`(?:\p{Emoji_Modifier_Base}\p{Emoji_Modifier}|\p{Emoji_Presentation}|\p{Emoji}\uFE0F)`;
const EMOJI_SHAPED = new RegExp(
  String.raw`^(?:\p{Regional_Indicator}{2}|\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}|${ELEMENT}(?:\u200D${ELEMENT})*)$`,
  "u",
);
export const MAX_EMOJI_FIELD_LENGTH = 32;

export interface EmojiRules {
  /** One emoji glyph in canonical form, or undefined. A text-presentation base ("❤") gains U+FE0F. */
  singleEmoji: (raw: unknown) => string | undefined;
  /** A stored value as the UI keeps it: canonical when provably one emoji, as stored when this
   * engine cannot tell (the relay already accepted it), undefined when it is plainly not one. */
  storedEmoji: (raw: string | null | undefined) => string | undefined;
}

/** The rules for an engine with (`true`) or without the RegExp `v` flag. */
export function emojiRules(hasUnicodeSets: boolean): EmojiRules {
  const rgi = hasUnicodeSets ? new RegExp("^\\p{RGI_Emoji}$", "v") : undefined;
  const isOne = (s: string) => (rgi ? rgi.test(s) : ONE_GLYPH.test(s) || PICKER_SEQUENCES.has(s));
  const singleEmoji = (raw: unknown): string | undefined => {
    if (typeof raw !== "string") return undefined;
    const s = raw.trim();
    if (!s || s.length > MAX_EMOJI_FIELD_LENGTH) return undefined;
    if (isOne(s)) return s;
    return isOne(`${s}\uFE0F`) ? `${s}\uFE0F` : undefined;
  };
  const storedEmoji = (raw: string | null | undefined): string | undefined => {
    const one = singleEmoji(raw);
    if (one || rgi || !raw) return one;
    const s = raw.trim();
    return s.length <= MAX_EMOJI_FIELD_LENGTH && EMOJI_SHAPED.test(s) ? s : undefined;
  };
  return { singleEmoji, storedEmoji };
}

export const { singleEmoji, storedEmoji } = emojiRules("unicodeSets" in RegExp.prototype);
